// extracted by mini-css-extract-plugin
export default {"node-stock":"Stock_node-stock__Q0mhd","empty-node-stock":"Stock_empty-node-stock__njFZk","hiddenContent":"Stock_hiddenContent__TUCpy"};